import { useEffect, type ReactElement } from "react"
import { Navigate } from "react-router-dom"
import { useAppSelector } from "hooks/hooksStore"
import useCommon from "hooks/useCommon"
import LoginPage from "pages/Auth/LoginPage"
import { RootState } from "store/store"
import { moduleOrder } from "routes/routePermissions"
import { getAvailableModulePath, parseJwt } from "utils/helpers"
import { destroyAccessToken, getAccessToken, removeRefreshToken } from "utils/token"

const RootRedirect = ({ token }: { token: string }): ReactElement | null => {
  const { authUser } = useAppSelector((state: RootState) => state.common)
  const { setAuthUser } = useCommon()
  const parsedUser = parseJwt(token)

  useEffect(() => {
    if (authUser) return

    if (parsedUser) {
      setAuthUser(parsedUser)
      return
    }

    destroyAccessToken()
    removeRefreshToken()
  }, [authUser, token, parsedUser])

  if (!authUser) return parsedUser ? null : <LoginPage />

  const availableModulePath = getAvailableModulePath(authUser.roles, moduleOrder)
  return <Navigate to={availableModulePath ?? "/no-access"} replace />
}

const RootRoute = (): ReactElement => {
  const token = getAccessToken()
  if (!token) return <LoginPage />
  return <RootRedirect token={token} />
}

export default RootRoute
